  import { FaRegSadTear, FaCheck } from "react-icons/fa";
  import { BiFolderOpen } from "react-icons/bi";
  import { AiFillEdit, AiFillDelete } from "react-icons/ai";  
  import { MdSell } from "react-icons/md";  
  import { NavLink, useNavigate } from "react-router-dom";
  import useFetch from "../Components/FetchHook";
  import ReactLoading from 'react-loading';
  import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css'
  import useFetchWithAuthorization from "../Apis/useFetchWithAuthorization";
  import { useEffect, useState } from "react";
  import { useCookies } from "react-cookie";


  const Myproducts = () => {
    const navigate = useNavigate(); // Initialize the useNavigate hook
    
    const handleAddProduct = () => {
      navigate("/Admin/addproducts"); // Navigate to the "/add-product" route when the button is clicked
    };

    const [yourData, setYourData] = useState([]); // State variable for yourData
    const { data: userData, loading: userLoading, error: userDataError } = useFetchWithAuthorization("https://campus-closet-server.vercel.app/profile");
    const { data, pending, error } = useFetch("https://campus-closet-server.vercel.app/items/products"); // Fetch data from the specified URL using the custom hook

    const [waiting, setwaiting]=useState(false)
    
    useEffect(() => {
      // Update yourData when data and userData change
      if (data && userData) {
        setYourData(data.filter((item) => item.uid === userData.user.id));
      }
    }, [data, userData]);

    

    const loading = userLoading || pending;
  


    const [cookies] = useCookies(["token"]);
    const token = cookies.token;


    // // Handle delete functionality
    // const handleDelete = (pid) => {
    //   // Display a confirmation dialog to the user
    //   if (window.confirm("Are you sure you want to delete this item?")) {
    //     fetch(`https://campus-closet-server.vercel.app/products/${pid}`, {
    //       method: "DELETE",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       },
    //     })
    //       .then((response) => response.json())
    //       .then((data) => {
    //         console.log(data); // Handle the response data
    //         // Perform any additional actions after successful deletion
    //         toast.success("Item deleted successfully!", {
    //           position: toast.POSITION.TOP_CENTER,
    //           autoClose: 1000,
    //         });
    //         // Remove the deleted item from yourData array
    //         setYourData((prevData) => prevData.filter((item) => item.pid !== pid));
    //       })
    //       .catch((error) => {
    //         console.error(error); // Handle the error
    //         // Perform any error handling or display error messages
    //         toast.error("Error deleting the product. Please try again later.", {
    //           position: toast.POSITION.TOP_CENTER,
    //           autoClose: 3000,
    //         });
    //       });
    //   }
    // };

    const handleDelete = (pid) => {
      // Display a confirmation dialog to the user
      if (window.confirm("Are you sure you want to delete this item?")) {
        const maxRetries = 3; // Define the maximum number of retry attempts
        let retryCount = 0;
    
        const executeDelete = () => {
          fetch(`https://campus-closet-server.vercel.app/products/${pid}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then((data) => {
              console.log(data); // Handle the response data
              // Perform any additional actions after successful deletion
              toast.success("Item deleted successfully!", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 1000,
              });
              // Remove the deleted item from yourData array
              setYourData((prevData) => prevData.filter((item) => item.pid !== pid));
            })
            .catch((error) => {
              console.error(error); // Handle the error
              if (retryCount < maxRetries) {
                // Retry the DELETE request with exponential backoff
                const retryDelay = 1000 * Math.pow(2, retryCount);
                retryCount++;
                console.warn(`Retrying in ${retryDelay} milliseconds...`);
                setTimeout(executeDelete, retryDelay);
              } else {
                // Maximum retry attempts reached, display an error message
                toast.error("Error deleting the product. Please try again later.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                });
              }
            });
        };
    
        // Start the initial delete attempt
        executeDelete();
      }
    };
    


    //when an item is sold successfully
  const handleChangeStatus = (pid, currentStatus) => {
  // Toggle the status (true -> false or false -> true)
  const newStatus = !currentStatus;

  // Create a data object to send the new status to the server
  const data = { is_purchased: newStatus };
  setwaiting(true)
  fetch(`https://campus-closet-server.vercel.app/products/ispurchased/${pid}`, {
    method: "PATCH", // Use PATCH method to update the status
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((updatedItem) => {
      console.log(updatedItem); // Handle the response data
      // Display a toast message based on the response
      toast.success(`Item ${newStatus ? "Resold" : "Sold"} successfully!`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
        // Update the status of the item in your local data (yourData) based on the response
        setYourData((prevData) =>
        prevData.map((item) =>
          item.pid === pid ? { ...item, is_purchased: newStatus } : item
        )
      );
      setwaiting(false)
    })
    .catch((error) => {
      console.error(error); // Handle the error
      // Display an error toast message
      toast.error(
        `Error ${newStatus ? "reselling" : "selling"} the product. Please try again later.`,
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        }
      );
      setwaiting(false)
    });
};

    


    

    const handleEdit = (pid) => {
      navigate(`/Admin/Update/${pid}`); // Navigate to the "/Update/[pid]" route with the product ID
    };

  //Protecting the routes
  if (userDataError === "Unauthorized") {
    return(
    <div style={{ height: `calc(100vh - 100px)` }} className=" flex justify-center">
      <div>
        <h1>Unauthorized Access</h1>
        <button onClick={()=>navigate("/login")}
          className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center`} >
            Login
          </button>
      </div>
  </div>)
  }

  return (
    <section>
      {/* <div className="bg-slate-100 flex py-3">
          <h1 className="text-2xl mx-auto font-bold mb-4">Admin_Panel</h1>
      </div> */}
      <div style={{ minHeight: "calc(100vh - 70px)" }} className="mx-5 md:mx-10">
        {loading ? (
          // Show a loading message while data is being fetched
          <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
            <p>
              Loading...
              <ReactLoading type="spinningBubbles" color="#444654" height={'80px'} width={'80px'} />
            </p>
          </div>
        ) : error || userDataError ? (
          // Show an error message if there was an error fetching the data
          <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
            <p>Failed to fetch your products. login and try again 😢</p>
          </div>
        ) : yourData && yourData.length === 0 ? (
          // Show a message when there are no products
          <div className="text-center">
            <BiFolderOpen className="text-6xl m-auto text-gray-400 mb-5" />
            <h2 className="text-2xl mb-5">
              You don't have any products yet. Add some products!
            </h2>
            <button
              onClick={handleAddProduct}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Add Products
            </button>
          </div>
        ) : (
          // Render the products when there is data available
          <div className="text-center">
            <h2 className="text-2xl underline my-2">Your Products</h2>
            {yourData && (
              <div>
                {/* <div className="my-5">
                  <button
                      onClick={handleAddProduct}
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Add more Products
                  </button>
                </div> */}
                <div className="flex flex-wrap justify-center gap-4 my-5 mb-4">
                  {yourData
                    .map((item, index) => (
                      <div
                        key={index}
                        className="shadow-2xl h-auto w-72 rounded-md bg-white flex flex-col"
                        style={{ transition: "transform 0.3s ease-in-out" }}
                      >
                        {item.image ? (
                          // Show the product image if it exists
                          <div className="h-48">
                            <img
                              className="h-full w-full object-contain rounded-md"
                              src={item.image}
                              alt={item.description}
                            />
                          </div>
                        ) : (
                          // Show a placeholder icon if the product image is missing
                          <div className="flex items-center justify-center h-3/4 rounded-md bg-gray-100">
                            <FaRegSadTear className="text-4xl text-gray-500" />
                          </div>
                        )}
                        <div className="ml-2">
                          <p className="font-bold">{item.product_name}</p>
                          <p className="">KSh {item.price}</p>
                          <p>{item.description.slice(0, 150)}..</p>
                        </div>
                        <div className="flex justify-center gap-4 mt-2 mb-4">
                          <button
                            onClick={() => handleEdit(item.pid)}
                            className="border border-gray-400 rounded-md text-sm flex items-center px-2 cursor-pointer"
                          >
                            <span className="mr-2">
                              <AiFillEdit />
                            </span>
                            Edit
                          </button>
                          <button
                            onClick={()=>handleDelete(item.pid)}
                            className="border text-red-600 border-gray-400 rounded-md text-sm flex items-center px-2 cursor-pointer"
                          >
                            <span className="mr-2">
                              <AiFillDelete />
                            </span>
                            Delete
                          </button>
                          <button
                        disabled={waiting}
                        onClick={() => handleChangeStatus(item.pid, item.is_purchased)}
                        className={`border ${
                          item.is_purchased ? "text-green-600" : "text-yellow-600" // Use green for sold, yellow for in progress
                        } border-gray-400 rounded-md text-sm flex items-center px-2 cursor-pointer`}
                      >
                          <span className="mr-2">
                            {/* Depending on the current status, you can show different icons */}
                            {item.is_purchased ? <MdSell /> :   <FaCheck />}
                          </span>
                          {item.is_purchased ? "Resell" : "Sold"}
                      </button>

                        </div>
                      </div>
                    ))}
                </div>
                
              </div>
            )}
          </div>
        )}
      </div>
      <ToastContainer />
    </section>
  );
};

export default Myproducts;
